<template>
    <el-button class="code_btn" type="primary" :disabled="num" @click="codeGet">{{num?"("+num+")":"获取验证码"}}</el-button>
</template>
<script>
import { test } from '@/config/index';
export default {
    components: {},
    props: {
        tel: Number,
    },
    computed: {},
    data() {
        return {
            num: 0,
            dsq: null
        }
    },
    mounted() {},
    methods: {
        codeGet() {
            if (!(/^1[3456789]\d{9}$/).test(this.tel)) {
                this.$message({
                    type: 'error',
                    message: "请输入正确的电话号码"
                })
                return
            }
            this.num = 60
            this.dsq = setInterval(() => {
                this.num--
                if (!this.num) {
                    clearInterval(this.dsq)
                }
            }, 1000)
            this._ajax.post({
                url: "SendSms",
                data: {
                    TelNumber: this.tel
                },
                success: (res) => {
                    var msg = ""
                    if (test) {
                        msg = res.message + ":" + res.Results
                    } else {
                        msg = res.message
                    }
                    this.$message({
                        type: 'success',
                        message: msg
                    })
                }
            })
        }
    },
    beforeUnmount() {
        clearInterval(this.dsq)
    },
}
</script>
<style lang="scss">
.code_btn{
    height: 40px;
}
</style>